<script>
  export let tech
</script>
{#if tech.url}
  <a href={tech.url} style="display:flex;margin:0.25em;align-items:baseline;height:1.5em">
    {#if tech.iconUrl && false}
      <img src={tech.iconUrl} alt={tech.name} style="height:100%" class="image"/>
    {:else}
      <span>{tech.name}</span>
    {/if}
    </a>
{:else}
  <span>{tech.name}</span>
{/if}